import NamedDto from 'modules/base/dto/NamedDto';

export class InfrastructureElementLocationEditDto extends NamedDto {}

export default InfrastructureElementLocationEditDto;
